<script setup>
// import { ref, onMounted, computed } from 'vue'
import SettingsTheme from './SettingsTheme.vue';
import SettingsCalendarSetup from './SettingsCalendarSetup.vue';
import SettingsCalendarSettings from './SettingsCalendarSettings.vue';

</script>

<template>
    <SettingsTheme></SettingsTheme>
    <SettingsCalendarSetup></SettingsCalendarSetup>
    <settings-calendar-settings></settings-calendar-settings>
</template>

<style scoped>
</style>